import { EnumFormatterBaseValueConverter } from 'General/Resources/ValueConverters/EnumFormatterBase';

export class EnumFormatterValueConverter extends EnumFormatterBaseValueConverter {

}